import dayjs from 'dayjs'

const dateApiFormat = date => dayjs(date).startOf('day').format()

export default dateApiFormat
